const enableProxy = process.env.NODE_ENV === 'debug';
const enableProxy_development = process.env.NODE_ENV === 'development';
const enableProxy_production = process.env.NODE_ENV === 'production';
let env = window.config;
if (enableProxy) {
    env = Object.assign({}, env, {
        enableProxy,
        client_id: process.env.VUE_APP_OAUTH_CLINET_ID,
        secret: process.env.VUE_APP_OAUTH_SECRET,
        redirectHost: process.env.VUE_APP_OAUTH_REDIRECT,
        oauthHost: process.env.VUE_APP_OAUTH_HOST,
        // apiHost: process.env.VUE_APP_API,
        apiHost: '',
        scope: process.env.VUE_APP_OAUTH_SCOPE,
        portalHost: process.env.VUE_APP_PORTAL_HOST,
        newHireExternalLinks: "http://121.196.246.38/el.html?c=1WS1FreagAo",
        newHireLogin: {
            KEY: "E2842C540F0810C3F11F42427F48A3DE",
            IV: "0123456789ABCDEF"
        },
        encrypt_totalRewards: {
            KEY: "E2842C540F0810C3F11F42427F48A3DE",
            IV: "0123456789ABCDEF"
        }
    });
    window.config = env;
}
else if (enableProxy_development) {
    env = Object.assign({}, env, {
        // newHireExternalLinks:env.portalHost + "/el.html?c=1WS1FreagAo",
        newHireLogin: {
            KEY: "E2842C540F0810C3F11F42427F48A3DE",
            IV: "0123456789ABCDEF"
        },
        encrypt_totalRewards: {
            KEY: "E2842C540F0810C3F11F42427F48A3DE",
            IV: "0123456789ABCDEF"
        }
    });
    window.config = env;
}
else if (enableProxy_production) {
    env = Object.assign({}, env, {
        secret: "9eaf41f83f7943afbc6807478be9baff",
        // newHireExternalLinks:env.portalHost + "/el.html?c=1WS1FreagAo",
        newHireLogin: {
            KEY: "E2842C540F0810C3F11F42427F48A3DE",
            IV: "0123456789ABCDEF"
        },
        encrypt_totalRewards: {
            KEY: "E2842C540F0810C3F11F42427F48A3DE",
            IV: "0123456789ABCDEF"
        }
    });
    window.config = env;
}
export default env;
